<template>
  <v-layout row wrap>
    <!-- TABLE WITH PARAMS -->
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="availabilityIsParam"
        class="app-table app-table--availability"
        hide-actions
      >
        <!-- headers -->
        <template v-slot:headers="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.value"
              class="text-xs-center"
            >
              <span class="text--black app-text-medium small">
                {{ header.text }}
              </span>
            </th>
          </tr>
        </template>

        <!-- items -->
        <template v-slot:items="props">
          <tr>
            <td>
              <p class="my-0 text--black app-text-medium small">
                {{ props.item.name }}
              </p>
              <span>{{ props.item.description }}</span>
            </td>
            <td class="text-xs-center" v-for="day in days" :key="day">
              <v-checkbox
                v-model="props.item[day]"
                :readonly="readonly"
                :ripple="false"
                @change="checkSelectAll()"
                class="justify-center"
                hide-details
              ></v-checkbox>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>

    <!-- TABLE WITHOUT PARAMS -->
    <v-flex xs12 mt-4>
      <v-data-table
        :items="availabilityIsNotParam"
        hide-headers
        class="app-table app-table--availability-without-params"
        hide-actions
      >
        <!-- items -->
        <template v-slot:items="props">
          <tr>
            <td width="208px">
              <p class="my-0 text--black app-text-medium small">
                {{ props.item.name }}
              </p>
              <span>{{ props.item.description }}</span>
            </td>
            <td class="px-4">
              <v-checkbox
                v-model="props.item.mon"
                @change="selectAll(props.item)"
                :disabled="readonly"
                :ripple="false"
                hide-details
              ></v-checkbox>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'app-table-availability-rates',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    readonly: Boolean,
  },
  data() {
    return {
      selecAllChecked: false,
      headers: [
        {
          text: '',
          value: 'name',
          sortable: false,
          width: '160px',
          align: 'center',
        },
        ...['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].map((day, i) => ({
          text: ['M', 'T', 'W', 'T', 'F', 'S', 'S'][i],
          value: day,
          sortable: false,
          align: 'center',
        })),
      ],
      days: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
      items: [],
    };
  },
  computed: {
    availabilityIsParam() {
      return this.$lodash.filter(this.items, { param: '1' });
    },
    availabilityIsNotParam() {
      return this.$lodash.filter(this.items, { param: '0' });
    },
  },
  watch: {
    items: {
      handler() {
        this.$emit('input', this.items);
      },
      deep: true,
    },
  },
  created() {
    if (this.readonly) {
      this.$vuetify.icons.checkboxOn =
        'a-icon a-icon__checkbox a-icon__checkbox-on readonly';
      this.$vuetify.icons.checkboxOff =
        'a-icon a-icon__checkbox a-icon__checkbox-off readonly';
    }
    this.items =
      this.value && this.value.length > 0
        ? this.value
        : this.defaultItems(this.$store.getters['catalogs/availability']);
    this.checkSelectAll();
  },
  destroyed() {
    this.$vuetify.icons.checkboxOn =
      'a-icon a-icon__checkbox a-icon__checkbox-on';
    this.$vuetify.icons.checkboxOff =
      'a-icon a-icon__checkbox a-icon__checkbox-off';
  },
  methods: {
    checkSelectAll() {
      if (!Array.isArray(this.items)) {
        this.selecAllChecked = false;
        return false;
      }
      this.selecAllChecked = this.items.every((item) =>
        this.days.every((day) => item[day])
      );
      return this.selecAllChecked;
    },
    defaultItems(list, checked = false, pay = null) {
      return list.map((item) => {
        this.days.forEach((day) => {
          item[day] = checked;
        });
        if (item.pay != null) {
          item.pay = pay;
        }
        return item;
      });
    },
    selectAll(item) {
      this.days
        .filter((day) => day !== 'mon')
        .forEach((day) => {
          item[day] = item.mon;
        });
      this.checkSelectAll();
    },
  },
};
</script>

<style scoped lang="stylus">
.select-all
  padding 5px 0
  span
    font-weight 600

@media (max-width: 768px)
  tbody
    tr
      td
        display flex
        align-items center
        position relative
        padding 0 !important
        > div
          padding-top 0 !important
        &:before
          position absolute
          left 16px
          z-index 1
        .v-text-field
          justify-content center
      td:first-child
        display block

  .app-table--availability-without-params
    tbody
      tr
        display flex
        flex-direction row
        flex-wrap wrap
        td
          min-width 50%
          max-width 50%
          display flex
          padding 20px 16px !important
          .v-input--checkbox
            justify-content flex-end
        td:last-child
          min-width 100%
          height 70px
          &:before
            content: 'Pay/hour'
</style>



// WEBPACK FOOTER //
// src/components/app-table/app-table-availability-rates.vue